const copyBlocks = [
  {
    year: 1918,
    text: 'Save the Redwoods League was founded.',
  },
  {
    year: 1927,
    text: 'With leadership from Save the Redwoods League, the California State Park system is established and the first memorial grove is dedicated.'
  },
  {
    year: 2022,
    text: 'Save the Redwoods League completes the Forever Forest Campaign, setting the redwood range on a restoration trajectory.'
  }
]

export default copyBlocks
